import type { EventAppModules } from '../types/eventModules.js';

export interface ResolvedAgendaFilter {
  type: string;
  label: string;
  enabled: true;
  order: number;
}

const DEFAULTS: Record<string, { label: string; order: number }> = {
  keynote: { label: 'Keynote', order: 10 },
  talk: { label: 'Presentations', order: 20 },
  workshop: { label: 'Workshop', order: 30 },
  panel: { label: 'Panel', order: 40 },
  poster: { label: 'Poster Presentation', order: 50 },
  break: { label: 'Break', order: 60 },
  networking: { label: 'Networking', order: 70 },
  social: { label: 'Event', order: 80 },
};

function fallback(type: string): { label: string; order: number } {
  const words = type.replace(/[_-]+/g, ' ');
  return {
    label: words.replace(/\b\w/g, (letter) => letter.toUpperCase()),
    order: 500,
  };
}

export function resolveAgendaFilters(
  sessionTypes: readonly (string | null | undefined)[],
  modules?: EventAppModules,
): ResolvedAgendaFilter[] {
  const present = [...new Set(sessionTypes.map((value) => value?.trim().toLowerCase() ?? '').filter(Boolean))];
  const overrides = new Map(
    (modules?.agenda?.filters ?? []).map((override) => [override.type.trim().toLowerCase(), override]),
  );

  return present.flatMap((type) => {
    const defaults = DEFAULTS[type] ?? fallback(type);
    const override = overrides.get(type);
    if (override?.enabled === false) return [];
    return [{
      type,
      label: typeof override?.label === 'string' ? override.label.trim() : defaults.label,
      enabled: true as const,
      order: typeof override?.order === 'number' ? override.order : defaults.order,
    }];
  }).sort((left, right) => left.order - right.order || left.label.localeCompare(right.label));
}
